import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {alabaster, darkGray, white} from '/theme/color/on.color';
import {codGray, graniteGray} from '/theme/color/secondary.color';
import {getFontFamily} from '/util/text.util';

export const styles = StyleSheet.create({
  taskListContainer: {
    paddingHorizontal: indent * 0.25,
    backgroundColor: white,
    marginTop: indent * 0.5,
  },
  taskItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: 8,
    backgroundColor: alabaster,
    marginBottom: indent * 0.4,
    paddingLeft: indent,
    paddingRight: indent * 0.5,
    paddingTop: indent,
    paddingBottom: indent,
    width: '100%',
  },
  taskItemText: {
    color: darkGray,
    fontSize: 14,
    fontWeight: '600',
    marginLeft: indent * 0.5,
    flexShrink: 1,
  },
  checkboxStatusText: {
    color: darkGray,
    fontSize: 16,
    fontWeight: '600',
    marginBottom: indent * 0.4,
    marginLeft: indent * 0.25,
  },
  journeyKickOffCallText: {
    fontSize: 14,
    fontWeight: '400',
    marginTop: indent * 0.6,
    lineHeight: 20,
  },
  selectedText: {
    ...getFontFamily('regular'),
    color: graniteGray,
  },
  unSelectedText: {
    color: codGray,
  },
  firstWeekCompleteItem: {
    marginTop: indent * 0.5,
    marginRight: indent,
    marginBottom: indent * 1.25,
    marginLeft: 5,
  },
  firstWeekCompleteText: {
    color: codGray,
    fontSize: 16,
    fontWeight: '600',
  },
});
